<template>
  <ol
    class="garage-breadcrumbs container"
  >
    <li
      v-for="(breadcrumb, index) in filteredBreadcrumbs"
      :key="breadcrumb.to"
      class="garage-breadcrumb"
    >
      <a
        :href="breadcrumb.to"
      >
        <span >{{ breadcrumb.title }}</span>
      </a>
    </li>
  </ol>
</template>

<script
  setup
  lang="ts"
>
import type { GarageJsonldGarageReadGarageReadIdGarageReadNameGarageSlugHistoryReadSuggestedGarageRead } from '~/api/docs/api';

interface IProps {
  garage?: GarageJsonldGarageReadGarageReadIdGarageReadNameGarageSlugHistoryReadSuggestedGarageRead;
}

const props = defineProps<IProps>();

const route = useRoute();

const breadcrumbs = [
  { to: '/', title: 'Ranking Mechaników', visible: true },
  { to: '/mechanicy/', title: 'Mechanicy', visible: true },
  { to: `/mechanicy/${route.params['city']}/`, title: `Warsztaty ${props.garage?.city}`, visible: !!route.params['city'] },
  { to: `/mechanicy/${route.params['city']}/dzielnica/${props.garage?.quarterSlug}/`, title: props.garage?.quarter, visible: !!props.garage?.quarter }
];

// computed
const filteredBreadcrumbs = computed(() => breadcrumbs.filter(breadcrumb => breadcrumb.visible))


</script>

<style
  lang="scss"
  scoped
>
@import url('assets/styles/components/garage-breadcrumbs.scss');
</style>